module.exports = __webpack_public_path__ + "static/img/system2.6e8ff589.png";